'use strict'

import HttpClient from './HttpClient'
// import store from '../../store'

class Quote extends HttpClient {
  getQuoteAll (data = {}) {
    var url = '/api/admin/quote/list/all'

    return this.sendPost(url, this.headers, data)
  }
  getOneQuote (quoteId) {
    var url = '/api/admin/quote/' + quoteId

    return this.sendGet(url, this.headers)
  }
  updateQuote (data = {}) {
    var url = '/api/admin/quote/update'

    return this.sendPut(url, this.headers, data)
  }
}

export default Quote
